<template>
  <div>
    <Loader :loading="showLoader" />
    <v-toolbar color="#222222" flat dense class="mb-4">
      <v-icon color="#337b52" class="ml-2" size="40" @click="goBack">
        mdi-arrow-left-bold-circle
      </v-icon>
      <v-toolbar-title style="font-family: 'Material Design Icons'; font-size: 25px !important">
        {{ toobarTitle }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <img :src="logo" class="toolbar-icon" /> -->
    </v-toolbar>

    <v-container fluid class="main-content px-4">
      <v-row justify="center" align="stretch" class="ma-0">
        <v-col v-for="(card, index) in cards" :key="index" cols="12" sm="6" md="4" lg="3" class="pa-3 d-flex">
          <v-card class="elegant-card" :class="{ 'active-card': selectedCard === index }"
            @mouseover="hoverCard(index, true)" @mouseleave="hoverCard(index, false)" @click="selectCard(index)">
            <img :src="card.image" class="card-image" />
            <div class="card-bottom">
              <div class="card-title">{{ card.text }}</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { onMounted, ref, onUnmounted } from "vue";
import Loader from "@/components/Loader.vue";
import { getToolBarLogo } from "@/assets/Branding/branding.js";
import { useRouter } from "vue-router";
import oldwall1905 from "@/assets/Branding/Artinvest/OldWall/oldwall1905.jpg";
import oldwall40 from "@/assets/Branding/Artinvest/OldWall/oldwall40.jpg";
import oldwall38 from "@/assets/Branding/Artinvest/OldWall/oldwall38.jpg";
import oldwall232 from "@/assets/Branding/Artinvest/OldWall/oldwall232.jpg";

export default {
  name: 'OldWallView',
  components: {
    Loader,
  },
  setup() {
    const showLoader = ref(true);
    const logo = ref("");
    const router = useRouter();
    const selectedCard = ref(0);
    const toobarTitle = ref("Alter Wall");
    const cards = ref([
      { text: "Alter Wall Historie", image: oldwall1905, hover: false },
      { text: "Alter Wall 2-32", image: oldwall232, hover: false },
      { text: "Alter Wall 38", image: oldwall38, hover: false },
      { text: "Alter Wall 40", image: oldwall40, hover: false },
    ]);

    const goBack = () => {
      router.go(-1);
    };

    const hoverCard = (index, hover) => {
      cards.value[index].hover = hover;
    };

    const selectCard = (index) => {
      if (index === 0) {
        router.push({ name: "OldWallHistory" }).catch((err) => console.error("Routing error:", err));
      } else if (index === 1) {
        router.push({ name: "OldWall232" }).catch((err) => console.error("Routing error:", err));
      } else if (index === 2) {
        router.push({ name: "OldWall38" }).catch((err) => console.error("Routing error:", err));
      } else if (index === 3) {
        router.push({ name: "OldWall40" }).catch((err) => console.error("Routing error:", err));
      }
    };

    const isMobile = ref(window.innerWidth < 1024);

    const updateIsMobile = () => {
      isMobile.value = window.innerWidth < 1024;
    };

    window.addEventListener('resize', updateIsMobile);

    onMounted(async () => {
      logo.value = await getToolBarLogo();
      setTimeout(() => {
        showLoader.value = false;
      }, 800);
      updateIsMobile();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateIsMobile);
    });

    return {
      showLoader,
      logo,
      goBack,
      cards,
      hoverCard,
      selectCard,
      isMobile,
      toobarTitle
    };
  }
};
</script>

<style scoped>
.toolbar-icon {
  height: 30px;
  align-self: center;
  margin-right: 20px;
}

.elegant-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
  cursor: pointer;
}

.elegant-card:hover {
  transform: scale(1.03);
}

.card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.card-bottom {
  background-color: #ffffff;
  width: 100%;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.card-title {
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  color: #000000;
  font-weight: bold;
}
</style>
